export const startWebsiteMission = (id) => ({
  type: "START_WEBSITE_MISSION",
  id
});



// WEBPACK FOOTER //
// ./src/store/actions/help/website.js